export class HttpApi {
  public static filters = 'filtros';
  public static stations = 'estaciones';
}